import Vue from 'vue';
import util from '../utils/index';

Vue.filter('formatTime', function (value) {
  if (!value || value < 0) {
    return '';
  }
  return util.formatTime(value);
});

Vue.filter('formatDate', function (value,fmt) {
  return util.formatDate(value,fmt);
});

Vue.filter('formatStatus', function (val,status){
  return util.formatStatus(val,status)
});



// WEBPACK FOOTER //
// ./src/filters/date.js